<div [class]="classPrefix('MainPod')">
  <ul [class]="classPrefix('Pod0')">
    <li [class]="classPrefix('Pod0Item0')"  *ngFor="let field of sortFields">
      <h3>{{field.text | translate}}</h3>
      <wml-options-zero [props]="field.props"></wml-options-zero>
    </li>
  </ul>
</div>
